import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EnrollmentPaymentRedsysService } from '../../services/enrollment-payment-redsys.service';
import { EnrollmentPaymentRedsys } from '../../models/enrollment-payment-redsys.model';

@Component({
    selector: 'app-enrollment-payment-result',
    templateUrl: './enrollment-payment-result.component.html',
    styleUrls: ['./enrollment-payment-result.component.scss']
})
export class EnrollmentPaymentResultComponent implements OnInit {

    public headerTitle     : string = 'Inscripciones';
    public headerButtonText: string = 'Volver';
    public headerButtonIcon: string = 'arrow-left';
    public headerButtonUrl : string = '/inscripciones';

    public isLoadingData : boolean = true;
    public enrollmentCode: string;
    public paymentResponse: EnrollmentPaymentRedsys;

    public showSuccessMessage: boolean = false;
    public successMessage    : string;
    public successButtonText : string = 'Ver todas las inscripciones';
    public successButtonUrl  : string = '/inscripciones';

    public showApiErrorMessage: boolean = false;
    public apiErrorMessage    : string;

    public showErrorMessage: boolean = false;
    public errorMessage    : string;
    public errorButtonText : string = 'Volver al detalle de la inscripción';
    public errorButtonUrl  : string;

    constructor(
        private readonly router: Router,
        private readonly activatedRoute: ActivatedRoute,
        private readonly enrollmentPaymentService: EnrollmentPaymentRedsysService) { }

    ngOnInit(): void {

        this.enrollmentCode = this.activatedRoute.snapshot.params["code"];

        let route = this.router.url;
        if (route.includes('ok'))
        {
            this.showSuccess();
        }

        if (route.includes('ko'))
        {
            this.showError();
        }

    }

    private showSuccess() {

        this.resetError();
        this.showSuccessMessage = true;
        this.successMessage     = `Su proceso de pago para la inscripción <br/>${this.enrollmentCode}<br/> ha finalizado correctamente.`;

    }

    private showError() {

        this.isLoadingData = false;
        this.resetSuccess();
        this.errorButtonUrl = `/inscripcion/${this.enrollmentCode}/info`;
        this.showErrorMessage = true;
        this.errorMessage     = `No se ha podido efectuar el pago de la inscripción ${this.enrollmentCode}.<br/>Por favor, vuelva a intentarlo más tarde.`;

    }

    private resetSuccess() {

        this.showSuccessMessage = false;
        this.successMessage     = null;

    }

    private resetError() {

        this.showErrorMessage = false;
        this.errorMessage     = null;

    }

}
